export const modulo = (a, n) => {
    return ((a % n ) + n ) % n
}
